import {
    Description,
    Field,
    Textarea as HeadlessTextarea,
    Label,
} from '@headlessui/react';
import { useId } from 'react';

const Textarea = ({
    id,
    label,
    description,
    error,
    required = false,
    rows = 4,
    disabled = false,
    ...props
}) => {
    let uuid = useId();

    return (
        <Field disabled={disabled}>
            {label && (
                <Label
                    htmlFor={id || uuid}
                    className='mb-1 block text-sm/6 font-medium text-gray-900'
                >
                    {label}
                    {required && (
                        <span className='inline-block pl-1 text-red-800'>
                            *
                        </span>
                    )}
                </Label>
            )}
            {description && (
                <Description className='mb-1 text-sm/6 text-gray-500'>
                    {description}
                </Description>
            )}
            <div className='grid grid-cols-1'>
                <HeadlessTextarea
                    {...props}
                    id={id || uuid}
                    className='focus:outline-primary-600 block w-full resize-y rounded-md border-0 bg-white px-3 py-1.5 text-base text-gray-900 ring-0 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 read-only:bg-gray-50 read-only:text-gray-500 focus:outline-2 focus:-outline-offset-2 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 data-invalid:text-red-900 data-invalid:outline-red-300 data-invalid:placeholder:text-red-300 data-invalid:focus:outline-red-600 sm:text-sm/6'
                    rows={rows}
                    invalid={!!error}
                    required={required}
                />
                {error && (
                    <Description className='mt-1 text-sm text-red-600'>
                        {error}
                    </Description>
                )}
            </div>
        </Field>
    );
};

export default Textarea;
